<div class="top-panel" [ngClass]="cardClass">
  <div class="frame-1000007848">
    <div class="frame-1171276196">
      <div class="appointment-title">{{ title }}</div>
      <div class="frame-1000007572">
        <div class="count">{{ count === '0' ? '-' : count }}</div>
      </div>
    </div>
  </div>
  <div class="image-18">
    <img [src]="image" alt="Appointments Icon" />
  </div>
</div>
